import { render, staticRenderFns } from "./select-dict.vue?vue&type=template&id=10377713&scoped=true"
import script from "./select-dict.vue?vue&type=script&lang=js"
export * from "./select-dict.vue?vue&type=script&lang=js"
import style0 from "./select-dict.vue?vue&type=style&index=0&id=10377713&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10377713",
  null
  
)

export default component.exports